import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import ProcessTaskDetails from './ProcessTaskDetails';
import ProcessTaskDetailsTabState from './ProcessTaskDetailsTabState';

export default class ProcessTaskDetailsTabView extends BufferTabView<ProcessTaskDetailsTabState> {
  render(): this {
    const props = {
      processTaskId: this.model.get('processTaskId'),
    };
    renderToDOM(<ProcessTaskDetails {...props} />, this.el);
    return this;
  }

  remove(): Backbone.View<ProcessTaskDetailsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ProcessTaskDetailsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
